// @flow
import React, { Fragment, useEffect, useCallback } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import isEmpty from 'ramda/es/isEmpty';
import prop from 'ramda/es/prop';
import findIndex from 'ramda/es/findIndex';

import RadioButton, { RadioButtonGroup } from 'app/common/ui/RadioButton';
import { HeaderLvl3 } from 'app/common/layouts/markup';
import { DotsLoader } from 'app/common/components/Loader';
import EmptyWarn from 'app/common/layouts/EmptyWarn';
import nope from 'app/common/lib/nope';

import action from 'app/common/lib/action';
// $FlowFixMe
import { shippingMethodsFetch, SHOP_SHIPPING_CURRENT } from 'app/common/actions/shop/order/shipping';

import styles from './Shipping.module.scss';;


type ShippingType = {
  id: number,
  name: string,
  shippingMethodType: number,
}

/**
 * Компонент выбора доставки
 */

const Shipping = () => {
  const dispatch = useDispatch();

  const currentShippingId: number = useSelector(state => state.shop.order.shipping.currentShippingId, shallowEqual);

  const shippingMethods: Array<ShippingType> = useSelector(state => state.shop.order.shipping.data, shallowEqual);

  const lockedShippingIds: Array<number> = useSelector(state => state.shop.order.shipping.lockedShippingIds, shallowEqual);

  const loadingShipping: boolean = useSelector(state => state.shop.order.shipping.loading, shallowEqual);

  // запрос данных
  useEffect(() => {
    dispatch(shippingMethodsFetch());
  }, [dispatch]);

  // устанавливает текущий выбранный метод доставки по индексу в массиве доставок
  // если индекс -1, id метода и тип устанавливается в null
  const setCurrentShippingByIndex = useCallback((idx) => {
    if (idx === -1) {
      dispatch(action(SHOP_SHIPPING_CURRENT, {
        currentShippingId: null,
        shippingMethodType: null,
      }));
    }
    const {
      id: newCurrentShippingId = null,
      shippingMethodType: newShippingMethodType = null,
    } = prop(idx, shippingMethods) || {};
    dispatch(action(SHOP_SHIPPING_CURRENT, {
      currentShippingId: newCurrentShippingId,
      shippingMethodType: newShippingMethodType,
    }));
  }, [dispatch, shippingMethods]);

  // смена текущего метода доставки, на первый доступный элемент, после загрузки новых методов
  useEffect(() => {
    setCurrentShippingByIndex(0);
  }, [dispatch, setCurrentShippingByIndex]);

  // смена текущего метода доставки, если он заблокирован
  useEffect(() => {
    const newCurrentShippingIndex = findIndex(({ id }) => !lockedShippingIds.includes(id), shippingMethods);
    setCurrentShippingByIndex(newCurrentShippingIndex);
  }, [dispatch, setCurrentShippingByIndex, lockedShippingIds]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangeShippingMethod = useCallback((_, id) => {
    dispatch(action(SHOP_SHIPPING_CURRENT, { currentShippingId: parseInt(id, 10) }));
  }, [dispatch]);

  const nothing = !loadingShipping && isEmpty(shippingMethods);

  return (
    <Fragment>
      {nothing
        ? <EmptyWarn className={styles.warn}>{'Способы получения не найдены'}</EmptyWarn>
        : <HeaderLvl3>
          {'Способ получения'}
          {loadingShipping && <DotsLoader className={styles.loading} simple />}
        </HeaderLvl3>}
      {!nothing
        && <Fragment>
          {/* $FlowFixMe */}
          <RadioButtonGroup
            id="select"
            className={styles.radioButtonGroup}
            valueSelected={currentShippingId}
            onChange={handleChangeShippingMethod}
          >
            {shippingMethods.map(({ id, name: label }) => {
              const locked = lockedShippingIds.includes(id);
              return (
                // $FlowFixMe
                <RadioButton
                  key={id}
                  className={styles.radioButton}
                  label={locked ? `${label} — недоступно` : label}
                  value={id}
                  disabled={locked}
                />
              );
            })}
          </RadioButtonGroup>
          <a href="info" onClick={nope} className={styles.disabledLink}>
            {'Подробнее об условиях доставки'}
          </a>
        </Fragment>}
    </Fragment>
  );
};

export default Shipping;
